module.exports = __webpack_public_path__ + "assets/img/sabc_contact_a.webp?fdeed602a0a45d5c72a32ec47f2b8ed0";